
  import { Vue, Component, Prop } from "vue-property-decorator";

  import SearchableDocumentsList from "@/components/documents/SearchableDocumentsListNew.vue";
  import UploadDocument from "@/components/documents/UploadDocumentNew.vue";
  import { User } from "@/generated/graphql";

  @Component({
    components: {
      SearchableDocumentsList,
      UploadDocument,
    },
  })
  export default class DocumentsSidebar extends Vue {
    @Prop({ type: String, required: true }) readonly managerUserId!: string;
     @Prop({ type: Boolean, default: false }) readonly isCustomHeight!: boolean;
    @Prop({ type: String, default: "adjustBottom" }) readonly getBottom!: string;
    @Prop({ type: String, required: true }) readonly managerFullName!: string;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, default: undefined }) readonly managerId?: string;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;


    get query(): Object {
      return {
        _and: [
          {
            uploaded_by: {
              _eq: this.currentUser.id,
            },
          },
          {
            attached_to: {
              user_id: {
                _eq: this.managerUserId,
              },
            },
          },
        ],
      };
    }

    handleDocumentNumberChanged(num: number): void {
      this.$emit("documentNumberChanged", num);
    }
  }
